<template>
    <div class="container">
             <div class="row mt-4 ">
            <div class="col-12">
            

              <vue-good-table
                    class="table-blue-wide w-100"
                    v-if="!loading && books.length > 0"
                    :columns="columns"
                    :rows="books"
                    :paginationOptions="paginationOptions"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter'
                    }">
                     <template #table-row="{ column, row, formattedRow }">
                        <span v-if="column.field === 'link' || column.field === 'mime'">
                          <a
                            style="cursor: pointer;"
                            href="#"
                            role="button"
                            @click.prevent="downloadFile(row.link, row.mime)"
                          >
                            {{ row.link }}
                          </a> 
                        </span>
                        <span v-else>
                          {{ formattedRow[column.field] }} 
                        </span>
                      </template>
                  </vue-good-table>
                  <div v-else class="text-center">Please Wait, LOADING...</div>


    </div>
</div>


    </div>
    




</template>
<script>
import HttpRequests from '../httpRequests/httpRequests';
import { VueGoodTable } from 'vue-good-table-next';
const httpRequests=new HttpRequests()
export default{
  components:{VueGoodTable},
  data(){
    return{
      books:[],
      paginationOptions: {
        enabled: true,
        perPageDropdownEnabled: true,
        mode: 'pages',
        perPage: 10,
        perPageDropdown: [10, 25, 50, 75, 100]
      },
      columns: [{
        label: 'სახელწოდება',
        field: 'name',
      }, {
        label: 'ბმული',
        field: 'link',
      }],
      loading: false,
    }
    
  },
  mounted(){
    this.loading = true;
    httpRequests.getBooksFromMyug().then(response=>{
      this.books=response.data.data
      this.loading = false;
    })
  },
  methods:{
    downloadFile(file,mime){

      httpRequests.downloadFile(file).then(response=>{

  const fileBlob = new Blob([response.data], {type: mime})

  const fileURL = URL.createObjectURL(fileBlob);


  switch(mime){

    case 'application/pdf':

      window.open(fileURL+'#toolbar=0','_blank')

    break

    default:


    const downloadLink = document.createElement('a');
    downloadLink.href = fileURL;
    downloadLink.download = file.replace('online_books/','')+'.'+file.split('.').pop();
    document.body.appendChild(downloadLink);
    downloadLink.click();

    URL.revokeObjectURL(fileURL);


    }


})

}
  }
}


</script>
<style scoped>
@import '~vue-good-table-next/dist/vue-good-table-next.css';

td {
  min-height: 40px;
  padding-right: 4px;
  padding-left: 4px;
}
</style>